import { render, staticRenderFns } from "./DarkPricing.vue?vue&type=template&id=2d8d7ef6&"
import script from "./DarkPricing.vue?vue&type=script&setup=true&lang=js&"
export * from "./DarkPricing.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports